// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_9a0fa9f8","divBlock":"rdg_b1ea423f"};